// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"8e3f2e863aadfacfd1b0","293":"783a3460c07a296c5d84"}[chunkId] + ".js";
};